import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=7bbb2e94&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=7bbb2e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbb2e94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bbb2e94')) {
      api.createRecord('7bbb2e94', component.options)
    } else {
      api.reload('7bbb2e94', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=7bbb2e94&scoped=true&", function () {
      api.rerender('7bbb2e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eg3tNOmVeG0q/JS/comp/DocBox.vue"
export default component.exports